import type { Module } from 'vuex';
import { EmailTemplate } from '@/types/EmailTemplate';
import {RootState} from "@/store";

export interface EmailTemplatesState {
  emailTemplates: EmailTemplate[];
}

const emailTemplatesModule: Module<EmailTemplatesState, RootState> = {
  namespaced: true,

  state: (): EmailTemplatesState => ({
    emailTemplates: [],
  }),

  getters: {
    getById: (state) => (idEmailTemplate: number): EmailTemplate | undefined => {
      return state.emailTemplates.find(emailTemplate => emailTemplate.idEmailTemplate === idEmailTemplate);
    },
  },

  mutations: {
    setEmailTemplates(
      state,
      payload: { emailTemplates: Record<number, any> }
    ) {
      state.emailTemplates = Object
        .values(payload.emailTemplates)
        .map(raw => EmailTemplate.fromRaw(raw));
    },

    setEmailTemplateCreate(
      state,
      payload: {
        idEmailTemplate: number;
        name: string;
      }
    ) {
      const emailTemplate = new EmailTemplate(
        payload.idEmailTemplate,
        payload.name,
        false,
      );
      state.emailTemplates.push(emailTemplate);
    },

    setEmailTemplateDelete(
      state,
      payload: { idEmailTemplate: number }
    ) {
      state.emailTemplates = state.emailTemplates.filter(
        emailTemplate => emailTemplate.idEmailTemplate !== payload.idEmailTemplate
      );
    },
  },

  actions: {
    wsSetEmailTemplates({ commit }, payload) {
      commit('setEmailTemplates', payload);
    },
    wsEmailTemplateCreate({ commit }, payload) {
      commit('setEmailTemplateCreate', payload);
    },
    wsEmailTemplateDelete({ commit }, payload) {
      commit('setEmailTemplateDelete', payload);
    },
  },
};

export default emailTemplatesModule;
